var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box bg-white rounded-lg w-full",class:{
        'overflow-y-auto': _vm.overflowYAuto,
        'overflow-x-auto': _vm.overflowXAuto,
        'overflow-auto': _vm.overflowAuto,
        'p-5': !_vm.showHeader,
    }},[(_vm.showHeader)?[_c('div',{staticClass:"content-box__header h-9 rounded-t-lg",class:_vm.headerClasses},[_vm._t("header")],2),_c('div',{staticClass:"content-box__content p-5",class:_vm.contentClasses},[_vm._t("default")],2)]:_vm._t("default"),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }